import { render, staticRenderFns } from "./Complementary.vue?vue&type=template&id=452e8e7e&scoped=true"
import script from "./Complementary.vue?vue&type=script&lang=js"
export * from "./Complementary.vue?vue&type=script&lang=js"
import style0 from "./Complementary.vue?vue&type=style&index=0&id=452e8e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e8e7e",
  null
  
)

export default component.exports